import { SET_TRANSFER, SET_TRANSFERS } from "../../constants/transferConstants";

const initialState = {
  transfer: null,
  transfers: [],
  filteredTransfers: [],
};

const transferReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_TRANSFER:
      return {
        ...state,
        transfer: action.transfer,
      };
    case SET_TRANSFERS:
      return {
        ...state,
        transfers: action.filtered ? state.transfers : action.transfers,
        filteredTransfers: action.filtered ? action.transfers : state.filteredTransfers,
      };
    default:
      return state;
  }
};

export default transferReducer;
